import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const validateSSOToken_API_CALL = createAsyncThunk(
  'validateSSOToken_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'validateSSOToken_API_CALL/pending', payload: {} });
    const {
      requestBody,
      successFn = () => {},
      errorFn = () => {},
      finallyFn = () => {},
    } = payload;
    const { ssoToken } = requestBody;
    SecureClient({
      isEncrypted: false,
      customerId: null,
      route: 'validatetoken',
      payload: {
        ssoToken,
      },
      otherPayloadDetailsPresent: false,
      headers: {},
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({ type: 'validateSSOToken_API_CALL/fulfilled', payload: res });
        successFn(res);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'validateSSOToken_API_CALL/rejected', payload: err });
        errorFn(err);
      },
      finallyFn,
    });
  }
);

export const validateSSOToken_API_CALL_extrareducer = {
  [validateSSOToken_API_CALL.pending]: (state, action) => {
    state.validateSSOTokenAPICall.isLoading = true;
  },
  [validateSSOToken_API_CALL.fulfilled]: (state, action) => {
    state.validateSSOTokenAPICall.isLoading = false;
    state.validateSSOTokenAPICall.isSuccess = true;
    state.validateSSOTokenAPICall.isError = false;
    state.validateSSOTokenAPICall.response = action.payload;
  },
  [validateSSOToken_API_CALL.rejected]: (state, action) => {
    state.validateSSOTokenAPICall.isLoading = false;
    state.validateSSOTokenAPICall.isSuccess = false;
    state.validateSSOTokenAPICall.isError = true;
    state.validateSSOTokenAPICall.response = action.payload;
  },
};
